// extracted by mini-css-extract-plugin
module.exports = {"Privacy":"Privacy_Privacy__2lESr","Accordion":"Privacy_Accordion__3SIbM","Hint":"Privacy_Hint__12ixJ"};